var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var Shopify = require('./shopify');
var Utils = require('./utils');
var PostRow = require('./post-row');
var ScrollToTop = require('./scroll-to-top');

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  postsStyleTip: [],
  postsSalesEvent: [],
  mergedPostList: [],
  sortedByDate: [],
  curList: [],
  styleTipsRecieved: false,
  salesEventsRecieved: false,

  getInitialState: function() {
    return { title: "",
             excerpt: "",
             postLink: "",
             postRows: [],
             postList: [] }
  },

  componentDidMount: function() {
    document.title = "Style Tips - Ingledew's Shoes";

    Shopify.getBlog("style-tips", this.styleTipsGot);
    Shopify.getBlog("sales-events", this.salesEventsGot);
    this.scrollToTop('style-tips-page');
    jQuery(ReactDOM.findDOMNode(this.refs.btnLatestPosts)).addClass('active');
    setTimeout(function() { jQuery(window).scroll(); }, 300);
  },

  styleTipsGot: function(result) {
    var firstPost = result[0];
    
    this.postsStyleTip = _.map(result,
                               function(post) {
                                 post.postType = "Style & Tips";
                                 return post;
                               });
    this.styleTipsRecieved = true;
    if (this.salesEventsRecieved) {
      this.sortedByDate = this.mergeList();
      this.setRow1and2(_.clone(this.sortedByDate));
    }
  },

  salesEventsGot: function(result) {
    this.salesEventsRecieved = true;
    this.postsSalesEvent = _.map(result,
                                 function(post) {
                                    post.postType = "Sales & Events";
                                    return post;
                                 });
    if (this.styleTipsRecieved) {
      this.sortedByDate = this.mergeList();
      this.setRow1and2(_.clone(this.sortedByDate));
    }
  },

  checkIfPostExhausted: function() {
    if (0 == this.curList.length) {
      jQuery(this.refs.btnLoadMore).css('display', 'none');
    } else {
      jQuery(this.refs.btnLoadMore).css('display', 'inline-block');
    }
  },

  setRow1and2: function(postList) {
    var postRow1 = [];

    postRow1.push(postList.shift());
    if (postList.length) {
        postRow1.push(postList.shift());
    }
    this.refs.postRow1.setPosts(postRow1);

    var postRow2 = [];
    if (postList.length) {
      postRow2.push(postList.shift());
      if (postList.length) {
        postRow2.push(postList.shift());
      }
    }
    this.refs.postRow2.setPosts(postRow2);
    this.curList = postList;
    this.checkIfPostExhausted();
  },

  mergeList: function() {
    this.mergedPostList = this.postsStyleTip.concat(this.postsSalesEvent);
    var feautures = _.filter(this.mergedPostList,
                             function(post) {
                                return post.tags.indexOf("feature") >= 0;
                             });
    var feature = this.mergedPostList[0];
    if (feautures.length) {
      feature = feautures[0];
    }
    var post = Utils.reconstructPost(feature.content);

    jQuery(ReactDOM.findDOMNode(this.refs.headerImg)).css('background', 'url(' + feature.img + ') center bottom no-repeat');
    this.setState({ mainTitle: feature.title,
                    mainDesc: feature.excerpt,
                    postLink: feature.url });
    return _.sortBy(_.clone(this.mergedPostList),
                    function(post){
                        return Date.parse(post.date);
                    });
  },

  handleLoadMore: function() {
    var curRows = this.state.postList;
    var posts = [this.curList.shift()];

    if (this.curList.length) {
      posts.push(this.curList.shift());
    }
    curRows.push(<PostRow posts={posts} key={curRows.length} />);
    
    if (this.curList.length) {
      posts = [this.curList.shift()];
      if (this.curList.length) {
        posts.push(this.curList.shift());
      }
      curRows.push(<PostRow posts={post} key={curRows.length} />);
    }
    this.setState({ postList: curRows });
    this.checkIfPostExhausted();
  },

  handleShowLatestPosts: function(e) {
    this.moveUnderLine(e.target);
    this.setState({ postList: [] });
    this.setRow1and2(_.clone(this.sortedByDate));
  },

  handleShowStyleTipsPost: function(e) {
    this.moveUnderLine(e.target);
    this.setState({ postList: [] });
    this.setRow1and2(_.clone(this.postsStyleTip));
  },

  handleShowSaleEventsPosts: function(e) {
    this.moveUnderLine(e.target);
    this.setState({ postList: [] });
    this.setRow1and2(_.clone(this.postsSalesEvent));
  },

  moveUnderLine: function(el) {
    jQuery(el).parent('ul').find('li').removeClass('active');
    jQuery(el).parent('li').addClass("active");
  },

  rawMarkup: function() {
    return { __html: this.state.mainDesc };
  },

  render: function() {
    return <div>
        <header className="container">
            <Link to={this.state.postLink} className="row link-to-post">
                <div className="for-border">
                    <div ref="headerImg" className="header-img"></div>
                </div>
                <div className="text-wrap col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                    <p className="lead">- style tips -</p>
                    <h1>{this.state.mainTitle}</h1>
                    <div dangerouslySetInnerHTML={this.rawMarkup()}></div>
                </div>
            </Link>
        </header>
        <main id="content" className="container" role="main">
            <ul className="nav" id="blog-nav" role="tablist">
                <li ref="btnLatestPosts">
                    <a href="#latest-posts" role="tab" data-toggle="tab"
                       onClick={this.handleShowLatestPosts}>latest posts
                       <div className="for-underline"></div>
                    </a>
                </li>
                <li ref="btnStyleTipPost">
                    <a href="#style-tips" role="tab" data-toggle="tab"
                       onClick={this.handleShowStyleTipsPost}>style tips
                       <div className="for-underline"></div>
                    </a>
                </li>
                <li ref="btnSaleEventPosts">
                    <a href="#sales-events" role="tab" data-toggle="tab"
                       onClick={this.handleShowSaleEventsPosts}>sales & events
                       <div className="for-underline"></div>
                    </a>
                </li>
            </ul>
            <PostRow ref="postRow1" key={1} noFade={true}/>
            <PostRow ref="postRow2" key={2} />
            {this.state.postList}
            <button ref="btnLoadMore" onClick={this.handleLoadMore}
               className="btn btn-primary load-more">load more
            </button>
        </main>
      </div>
  }
});